import {createSelector} from '@ngrx/store';
import {selectSchooldashboardNew} from '../app.state';
import {sortByNumberThenByString} from '../../stateless/string';

export const selectBazenBanner = createSelector(
  selectSchooldashboardNew,
  (state) => state.bazenbanner
);

export const selectLicentiesPerLeerling = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.licentiesPerLeerling
);

export const selectGeactiveerdeLicenties = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.geactiveerdeLicenties
);

export const selectEducatieveAanbieders = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.educatieveAanbieders
);

export const selectActivatieGraad = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.activatieGraad
);

export const selectLeermiddelGebruik = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.leermiddelGebruik
);

export const selectAantalLeerlingen = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.aantalLeerlingen
);

export const selectGemiddeldGebruik = createSelector(
  selectBazenBanner,
  (bazenbanner) => bazenbanner?.gemiddeldGebruik
);

export const selectVakken = createSelector(
  selectSchooldashboardNew,
  (state) => state.vakken.map(vak => vak.header)
);

export const selectVakContent = (naam: string) => createSelector(
  selectSchooldashboardNew,
  (state) => state.vakken.find(vak => vak.header.naam === naam)?.content
);

export const selectOnderwijssoorten = createSelector(
  selectSchooldashboardNew,
  (state) =>
    sortByNumberThenByString(state.onderwijssoorten.map(os => os.header), ows => ows.sortScore, ows => ows.naam)
);

export const selectOnderwijssoortContent = (naam: string) => createSelector(
  selectSchooldashboardNew,
  (state) =>
    sortByNumberThenByString(state.onderwijssoorten.find(os => os.header.naam === naam)?.content, ows => ows.sortScore, ows => ows.naam)
);

export const selectItemByOnderwijssoortVak = (onderwijssoortNaam: string, vakNaam: string, isGegroepeerdOpOnderwijssoort: boolean) =>
  createSelector(
    selectSchooldashboardNew,
    (state) => isGegroepeerdOpOnderwijssoort
      ? state.onderwijssoorten.find(os => os.header.naam === onderwijssoortNaam)?.content?.find(c => c.naam === vakNaam)
      : state.vakken.find(os => os.header.naam === vakNaam)?.content?.find(c => c.naam === onderwijssoortNaam)
  );

export const selectOngekoppeldeLeermiddelen = createSelector(
    selectSchooldashboardNew,
    (state) => state.ongekoppeldeLeermiddelen?.header
);

export const selectOngekoppeldeLeermiddelenRegels = createSelector(
    selectSchooldashboardNew,
    (state) => state.ongekoppeldeLeermiddelen?.content
)
